import { get } from '@fable/api'
import { Button, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Author as AuthorType, Book } from '@fable/types'
import { useQuery } from 'react-query'
import { ExpandableDescription } from 'components/ExpandableDescription'
import { useBookQuery } from '../hooks'
import { Link } from 'react-router-dom'
import { routes } from 'app/store/routes'
import { BookCarousel } from 'components/carousels'

export const BookDetailAuthors = () => {
  const book = useBookQuery()

  return (
    <div>
      {book?.authors?.map((author, i) => (
        <Author key={i} author={author} book={book} index={i} />
      ))}
    </div>
  )
}

const Author = ({
  author,
  book,
  index,
}: {
  author: AuthorType
  book: Book
  index: number
}) => {
  const { colors } = useTheme()

  const { data, isLoading } = useQuery(
    ['author_books', author.slug],
    () => get(`/authors/${author.slug}/`),
    {
      enabled: !!author.slug,
    }
  )

  const booksData = data?.data?.books as Book[]
  const books = booksData?.filter((o) => o.id !== book?.id && o)

  return (
    <div
      className={css`
        &:not(:last-child) {
          padding-bottom: 40px;
          margin-bottom: 40px;
          border-bottom: 1px solid ${colors.whiteSmoke};
        }
      `}
    >
      <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
        {index === 0 ? 'About ' : ''}
        {author.name}
      </Text>
      <ExpandableDescription
        className={css`
          margin-top: 24px;
        `}
        truncate={12}
        description={author.biography}
      />
      <Link
        className={css`
          display: block;
          margin-top: 24px;
        `}
        to={`${routes.author}/${author.slug}`}
        target="_blank"
      >
        <Button secondary label="View profile" />
      </Link>
      <BookCarousel
        title={`Other books by ${author.name}`}
        books={books}
        loading={isLoading}
        titleSizing="XS"
      />
    </div>
  )
}
